module.exports = __webpack_public_path__ + "img/fondo_ilustrado.bd667101.png";